import { Component, inject } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {ModalTexteAdministrableComponent} from '../modal-texte-administrable/modal-texte-administrable.component';
import {ModalContactComponent} from '../modal-contact/modal-contact.component';
import { MatAnchor } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [MatAnchor, TranslateModule]
})
export class FooterComponent {
    private matDialog = inject(MatDialog);


    constructor() {
    }

    public openModal(code: string)
    {
        this.matDialog.open(ModalTexteAdministrableComponent, {
            data: code,
            width: '62%'
        });
    }

    public openModalContact(): void
    {
        this.matDialog.open(ModalContactComponent, {});
    }
}
